<template>
  <div>
    <div class="row mb-2 pe-4">
      <div class="col-lg-12 col-md-12 col-12 d-flex align-items-center">
        <div class="color-common">
          <h3 class="title-page mb-0 ps-3">CRM REPORTS</h3>
        </div>
      </div>
    </div>
    <div class="page-header align-items-start min-vh-100 my-transacions">
      <span class="mask bg-white"></span>
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-12 mx-auto mt-4">
            <div class="row">
              <strong> Point Report </strong>
            </div>
            <div class="row mt-3">
              <div class="col-lg-4 col-md-12 col-12">
                <div class="row">
                  <div
                    class="col-lg-3 col-md-3 col-3 d-flex justify-content-end align-items-center"
                  >
                    Time
                  </div>
                  <div class="col-lg-8 col-md-6 col-9">
                    <Multiselect
                      v-model="searchForm.time_type"
                      :options="times"
                      :canClear="false"
                      @change="timeChange($event)"
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-12 col-12">
                <div class="row">
                  <div
                    class="col-lg-3 col-md-3 col-3 d-flex justify-content-end align-items-center"
                  >
                    Branch
                  </div>
                  <div class="col-lg-8 col-md-6 col-9">
                    <Multiselect
                      v-model="searchForm.branch_id"
                      :options="branches"
                      :canClear="false"
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-12 col-12">
                <div class="row">
                  <div
                    class="col-lg-3 col-md-3 col-3 d-flex justify-content-end align-items-center"
                  >
                    Type
                  </div>
                  <div class="col-lg-8 col-md-6 col-9">
                    <Multiselect
                      v-model="searchForm.movement_type"
                      :options="movementTypes"
                      :canClear="false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-3" v-if="isShowTimeCustom">
              <div class="col-lg-4 col-md-12 col-12">
                <div class="row">
                  <div
                    class="col-lg-3 col-md-3 col-3 d-flex justify-content-end align-items-center"
                  >
                    From
                  </div>
                  <div class="col-lg-8 col-md-6 col-9">
                    <Datepicker
                      :enableTimePicker="false"
                      class="date-time-dashboad"
                      v-model="searchForm.from_date"
                      :format="format"
                      auto-apply
                      :clearable="false"
                      :max-date="new Date()"
                      @update:model-value="onChangeFromDate"
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-12 col-12 pt-custtom">
                <div class="row">
                  <div
                    class="col-lg-3 col-md-3 col-3 d-flex justify-content-end align-items-center"
                  >
                    To
                  </div>
                  <div class="col-lg-8 col-md-6 col-9">
                    <Datepicker
                      :enableTimePicker="false"
                      class="date-time-dashboad"
                      v-model="searchForm.to_date"
                      :format="format"
                      auto-apply
                      :clearable="false"
                      :min-date="searchForm.from_date"
                      :max-date="new Date()"
                      @update:model-value="onChangeToDate"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-lg-12 col-md-12 col-12">
                <div class="row">
                  <div
                    class="col-lg-1 col-md-3 col-3 d-flex justify-content-end align-items-center"
                  >
                    Search
                  </div>
                  <div class="col-lg-8 col-md-6 col-9">
                    <input
                      class="nosubmit"
                      type="search"
                      id="keyword_search"
                      v-model="searchForm.search_keyword"
                      name="keyword_search"
                      placeholder="Enter member ID, name, phone number, branch, receipt no ..."
                      @keydown.enter="handleSearchEnter"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-4 ps-3">
              <div class="col-lg-9 col-md-9 col-3 d-flex">
                <div class="dropdown">
                  <button
                    class="btn btn-secondary dropdown-toggle btn-sm"
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    aria-haspopup="true"
                  >
                    Download
                  </button>
                  <ul
                    class="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li>
                      <a
                        class="dropdown-item"
                        @click="exportFile('csv')"
                        href="#"
                        >Export CSV</a
                      >
                    </li>
                    <li>
                      <a
                        class="dropdown-item"
                        @click="exportFile('xlsx')"
                        href="#"
                        >Export Excel</a
                      >
                    </li>
                  </ul>
                </div>
                <div style="margin-left: 3vh">
                  <material-button
                    class="btn-background btn-sm"
                    @click="search()"
                    style="width: 162.52px"
                  >
                    Search
                  </material-button>
                </div>
              </div>
            </div>
            <div class="row mt-3 g-2 point-summary">
              <div class="col-lg col-md-4 col-6">
                <div class="summary-card">
                  <span class="summary-icon icon-issued material-icons-round"
                    >add_circle</span
                  >
                  <div class="summary-content">
                    <div class="summary-label">Points Issued</div>
                    <div class="summary-value">
                      {{ pointSummary.points_issued_format }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg col-md-4 col-6">
                <div class="summary-card">
                  <span class="summary-icon icon-pending material-icons-round"
                    >hourglass_empty</span
                  >
                  <div class="summary-content">
                    <div class="summary-label">Points Pending</div>
                    <div class="summary-value">
                      {{ pointSummary.points_pending_format }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg col-md-4 col-6">
                <div class="summary-card">
                  <span class="summary-icon icon-redeemed material-icons-round"
                    >redeem</span
                  >
                  <div class="summary-content">
                    <div class="summary-label">Points Redeemed</div>
                    <div class="summary-value">
                      {{ pointSummary.points_redeemed_format }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg col-md-4 col-6">
                <div class="summary-card">
                  <span class="summary-icon icon-expired material-icons-round"
                    >event_busy</span
                  >
                  <div class="summary-content">
                    <div class="summary-label">Points Expired</div>
                    <div class="summary-value">
                      {{ pointSummary.points_expired_format }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg col-md-4 col-6">
                <div class="summary-card summary-card-total">
                  <span class="summary-icon icon-balance material-icons-round"
                    >savings</span
                  >
                  <div class="summary-content">
                    <div class="summary-label">
                      Outstanding Balance
                      <span class="summary-note">all members, as of now</span>
                    </div>
                    <div class="summary-value">
                      {{ pointSummary.outstanding_balance_format }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-12">
                <div class="card-custom">
                  <div class="px-0 pb-2">
                    <div class="table-responsive p-0 custom-table">
                      <table class="table align-items-center mb-0">
                        <thead>
                          <tr>
                            <th class="text-center font-weight-bolder">
                              Row No
                            </th>
                            <th class="text-center font-weight-bolder">Date</th>
                            <th class="text-center font-weight-bolder">
                              Member ID
                            </th>
                            <th class="text-center font-weight-bolder">
                              Member Name
                            </th>
                            <th class="text-center font-weight-bolder">
                              Phone No
                            </th>
                            <th class="text-center font-weight-bolder">
                              Branch
                            </th>
                            <th class="text-center font-weight-bolder">Type</th>
                            <th class="text-center font-weight-bolder">
                              Receipt No
                            </th>
                            <th class="text-center font-weight-bolder">
                              Points
                            </th>
                            <th class="text-center font-weight-bolder">
                              Expiry Date
                            </th>
                            <th class="text-center font-weight-bolder">
                              Points Used
                            </th>
                            <th class="text-center font-weight-bolder">
                              Points Remaining
                            </th>
                          </tr>
                        </thead>
                        <tbody v-if="movements.length">
                          <tr v-for="(value, key) in movements" :key="key">
                            <td class="text-center text-xss">
                              {{ rowNo(key) }}
                            </td>
                            <td class="text-center text-xss">
                              {{ value.movement_date_format }}
                            </td>
                            <td class="text-center text-xss">
                              {{ value.member_id_format }}
                            </td>
                            <td class="text-center text-xss">
                              {{ value.member_name }}
                            </td>
                            <td class="text-center text-xss">
                              {{ value.phone_number }}
                            </td>
                            <td class="text-center text-xss">
                              {{ value.branch_name }}
                            </td>
                            <td class="text-center text-xss">
                              <span
                                class="point-badge"
                                :class="badgeClass(value)"
                                >{{ value.movement_type_format }}</span
                              >
                            </td>
                            <td class="text-center text-xss">
                              {{ value.receipt_no }}
                            </td>
                            <td
                              class="text-center text-xss font-weight-bold"
                              :class="
                                value.points < 0 ? 'text-danger' : 'text-success'
                              "
                            >
                              {{ value.points_format }}
                            </td>
                            <td class="text-center text-xss">
                              {{ value.expiry_date_format }}
                            </td>
                            <td class="text-center text-xss">
                              {{ value.points_used }}
                            </td>
                            <td class="text-center text-xss">
                              {{ value.points_remaining }}
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td colspan="12" class="text-center">
                              No point movements found
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <pagination
                    v-if="pagination.last_page > 1"
                    :pagination="pagination"
                    :current_page="pagination.current_page"
                    :last_page="pagination.last_page"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="position-fixed top-1 end-1 z-index-2 message-success">
        <material-snackbar
          v-if="snackbar === 'danger' || snackbar === 'success'"
          title=""
          date=""
          :description="message"
          :icon="{ component: 'campaign', color: 'white' }"
          :color="snackbar"
          :close-handler="closeSnackbar"
        />
      </div>
      <material-loading :active="loaderActive" />
    </div>

    <!-- Hidden Export Form -->
    <form :action="`${actionDownload}/merchant/download-point-report`" method="POST">
      <input type="hidden" name="merchantId" :value="merchantIdExport" />
      <input type="hidden" name="merchant_code" :value="merchantCode" />
      <input type="hidden" name="token" :value="token" />
      <input
        type="hidden"
        name="search_keyword"
        :value="searchForm.search_keyword"
      />
      <input type="hidden" name="time_type" :value="searchForm.time_type" />
      <input type="hidden" name="branch_id" :value="searchForm.branch_id" />
      <input
        type="hidden"
        name="movement_type"
        :value="searchForm.movement_type"
      />
      <input
        type="hidden"
        name="from_date"
        :value="dateFormat(searchForm.from_date)"
      />
      <input
        type="hidden"
        name="to_date"
        :value="dateFormat(searchForm.to_date)"
      />
      <input type="hidden" name="action" value="export" />
      <input type="hidden" name="action_export" :value="action_export" />
      <input type="hidden" name="checkExport" :value="checkExport" />
      <input id="downloadForm" type="submit" class="d-none" />
    </form>
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import "bootstrap/dist/js/bootstrap.bundle";
import MaterialLoading from "@/components/MaterialLoading.vue";
import MaterialButton from "@/components/MaterialButton.vue";
import Pagination from "@/components/Pagination.vue";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import moment from "moment";
import DashboardReportService from "../../services/dashboardReport.service";
import TokenService from "../../services/token.service";
import CommonFunctionService from "../../services/commonFunction.service";
import $ from "jquery";

export default {
  name: "point-report",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    MaterialButton,
    Pagination,
    Multiselect,
    Datepicker,
  },
  data() {
    return {
      token: TokenService.getLocalAccessToken(),
      actionDownload: process.env.VUE_APP_BASE_URL,
      merchantIdExport: localStorage.getItem("MERCHANT_ID", ""),
      merchantCode: localStorage.getItem("MERCHANT_CODE", ""),
      movements: [],
      pagination: {},
      page: 1,
      action_export: "csv",
      checkExport: false,
      snackbar: null,
      message: "",
      loaderActive: false,
      isShowTimeCustom: true,
      branches: [],
      times: [
        { value: 0, label: "All time" },
        { value: 1, label: "Today" },
        { value: 2, label: "Yesterday" },
        { value: 3, label: "Last 7 days" },
        { value: 4, label: "Last 30 days" },
        { value: 5, label: "This month" },
        { value: 9, label: "Custom" },
      ],
      movementTypes: [
        { value: "", label: "All" },
        { value: "earned", label: "Earned" },
        { value: "redeemed", label: "Redeemed" },
        { value: "expired", label: "Expired" },
      ],
      pointSummary: {
        points_issued_format: "0",
        points_pending_format: "0",
        points_redeemed_format: "0",
        points_expired_format: "0",
        outstanding_balance_format: "0",
      },
      searchForm: {
        time_type: 9,
        from_date: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        to_date: new Date(),
        search_keyword: "",
        branch_id: 0,
        movement_type: "",
        page: 1,
      },
    };
  },
  created() {
    if (this.$route.query.page) {
      this.page = this.$route.query.page;
    }
    this.getBranches();
    this.getList(this.page);
  },
  methods: {
    getBranches() {
      DashboardReportService.getFilterDataTopupReport().then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.branches = response.data.data.branches || [];
          }
        },
        () => {
          this.branches = [];
        }
      );
    },
    getList(page) {
      this.showLoader();
      this.searchForm.page = page;

      const params = {
        ...this.searchForm,
        from_date: this.dateFormat(this.searchForm.from_date),
        to_date: this.dateFormat(this.searchForm.to_date),
      };

      DashboardReportService.getDataPointReport(params).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.movements = response.data.data.items || [];
            this.pagination = response.data.data || {};
            this.pointSummary =
              response.data.data.point_summary || this.pointSummary;
            this.page = this.pagination.current_page || 1;
            this.checkExport = true;
            this.hideLoader();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.hideLoader();
            this.setTimeOutNotification();
          }
        },
        (error) => {
          this.snackbar = "danger";
          this.message =
            error.response?.data?.result?.message ||
            "An error occurred while fetching data";
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },
    rowNo(key) {
      const perPage = this.pagination.per_page || 0;
      const currentPage = this.pagination.current_page || 1;

      return perPage * (currentPage - 1) + key + 1;
    },
    badgeClass(value) {
      if (value.movement_type === "redeemed") {
        return "badge-redeemed";
      }
      if (value.movement_type === "expired") {
        return "badge-expired";
      }
      if (value.earned_status === 0) {
        return "badge-pending";
      }

      return "badge-earned";
    },
    search() {
      this.page = 1;
      this.getList(this.page);
    },
    handleSearchEnter() {
      this.search();
    },
    timeChange($event) {
      this.isShowTimeCustom = $event == 9;
    },
    format(date) {
      return CommonFunctionService.formatDateShow(date);
    },
    dateFormat(date) {
      if (!date) {
        return "";
      }
      return moment(date).format("YYYY-MM-DD");
    },
    onChangeFromDate(from_date) {
      this.searchForm.from_date = from_date;
      if (
        !this.searchForm.to_date ||
        moment(this.searchForm.to_date) < moment(from_date)
      ) {
        this.searchForm.to_date = new Date();
      }
    },
    onChangeToDate(to_date) {
      this.searchForm.to_date = to_date;
    },
    exportFile(type = "csv") {
      this.action_export = type;
      setTimeout(() => {
        $("#downloadForm").click();
      }, 150);
    },
    closeSnackbar() {
      this.snackbar = null;
    },
    showLoader() {
      this.loaderActive = true;
    },
    hideLoader() {
      this.loaderActive = false;
    },
    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
  },
};
</script>

<style scoped>
.message-success {
  z-index: 9999;
}

input[type="search"] {
  border: none;
  background: transparent;
  margin: 0;
  padding: 7px 8px;
  font-size: 14px;
  color: inherit;
  border: 1px solid transparent;
  border-radius: inherit;
}

input[type="search"]::placeholder {
  color: #bbb;
  text-align: left;
  font-weight: normal;
}

input[type="search"]:focus {
  border-color: #72959d;
  outline: none;
  border: none;
  border-bottom: 2px solid #72959d;
}

input.nosubmit {
  border-bottom: 1px solid #d2d2d2;
  width: 100%;
  padding: 9px 4px 9px 40px;
  background: transparent
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' class='bi bi-search' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'%3E%3C/path%3E%3C/svg%3E")
    no-repeat 13px center;
}

.date-time-dashboad .dp__input_wrap {
  min-width: 200px !important;
  width: 250px;
}

.point-summary .summary-card {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  height: 100%;
  padding: 16px;
  border: 1px solid #eef0f3;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 6px 20px rgba(20, 45, 82, 0.06);
  transition: box-shadow 0.15s ease, transform 0.15s ease;
}

.point-summary .summary-card:hover {
  box-shadow: 0 10px 26px rgba(20, 45, 82, 0.1);
  transform: translateY(-2px);
}

.point-summary .summary-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  color: #fff;
  font-size: 22px;
}

.point-summary .icon-issued {
  background: linear-gradient(135deg, #2f9e78, #38b6a0);
}

.point-summary .icon-pending {
  background: linear-gradient(135deg, #e08a3c, #f2b562);
}

.point-summary .icon-redeemed {
  background: linear-gradient(135deg, #9b5de5, #c084f5);
}

.point-summary .icon-expired {
  background: linear-gradient(135deg, #d1495b, #ea7480);
}

.point-summary .icon-balance {
  background: linear-gradient(135deg, #1f6f78, #38b6a0);
}

.point-summary .summary-content {
  min-width: 0;
}

.point-summary .summary-card-total {
  background: linear-gradient(135deg, #f3f6ff 0%, #eef7f4 100%);
  border-color: #cfe4e0;
}

.point-summary .summary-label {
  font-size: 11px;
  color: #8392ab;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  line-height: 1.3;
  min-height: 30px;
}

.point-summary .summary-note {
  display: block;
  font-size: 10px;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0;
  color: #a5b0c0;
}

.point-summary .summary-value {
  margin-top: 4px;
  font-size: 20px;
  font-weight: 700;
  color: #1f2d3d;
  word-break: break-word;
}

.point-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  white-space: nowrap;
}

.badge-earned {
  background: #e4f5ee;
  color: #1f7a5c;
}

.badge-pending {
  background: #fdf1e3;
  color: #a5651f;
}

.badge-redeemed {
  background: #f2e9fd;
  color: #6c3bab;
}

.badge-expired {
  background: #fbe7e9;
  color: #a52a37;
}

@media only screen and (max-width: 991px) {
  .pt-custtom {
    padding-top: 7px;
  }
}
</style>
